import { createPageNavigator } from "@-/dev.improve.haniverse.lib.navigator.page";
import { useCallback } from "react";

function useNavigator() {
  return useCallback(
    () => ({
      // The fresh-install welcome/auth screen lives at the `(nav)` level (a sibling of the
      // startup `index` redirect), OUTSIDE the `(nav)/(app)` group — so it shows none of the
      // app's bottom tabs and the user must pick a sign-in option before entering the app. The
      // `PrimaryControlsStrip` self-hides on this route (see `NavLayoutContent`), so no header renders here.
      href: {
        pathname: "/(nav)/auth",
      },
      queries: [],
    }),
    [],
  );
}

export const useAuthPageNavigator = createPageNavigator<void>({
  useNavigator,
});
